export const SSR = true;
export const BASE_URL = 'https://inclassica.com';
export const API_BASE_URL = 'https://cors-anywhere.herokuapp.com/https://yerevan-park.codics.solutions/'; // DEV
// export const API_BASE_URL = 'https://cors-anywhere.herokuapp.com/https://yerevan-park.codics.solutions/';   //PROD

export const DEFAULT_META = {
  siteName: 'inclassica.com',
  img: '/img/seo/home.png',
  favicon: {
    icon: 'favicon.ico',
    web: {
      '16x16': 'favicon-16x16.png',
      '32x32': 'favicon-32x32.png',
    },
    ios: {
      '180x180': 'apple-touch-icon.png',
    },
    android: {
      '192x192': 'android-chrome-192x192.png',
      '512x512': 'android-chrome-512x512.png',
    },
  },
  app: {
    ios: {
      app_name: 'InClassica',
      app_store_id: '',
      url: '',
    },
    android: {
      app_name: 'InClassica',
      package: '',
      url: '',
    },
  },
  social: {
    twitter: {
      card: 'test',
      site: '@name',
    },
  },
};
